import routes from "@/routers/routes";
import PageHeader from "@/app/shared/page-header";
import CreateEditSystemSetting from "@/app/shared/settings/general/create-edit";
import { useEffect, useState } from "react";
import { fetchSystemSetting } from "@/server/api-services";
import { SystemSetting } from "@/types";

export default function CreateSystemSettingPage() {
    
    const [systemSetting, setSystemSetting] = useState({} as SystemSetting);

    const pageHeader = {
        title: "Create System Setting",
        breadcrumb: [
            {
                href: routes.eCommerce.dashboard,
                name: "home",
            },
            {
                name: "Add New Setting",
            },
        ],
    };

    useEffect(() => {
        getSystemSetting();
    }, []);

    const getSystemSetting = async () => {

        const response = await fetchSystemSetting();

        if (response.statusCode !== 200) {
            return;
        }

        var data = response.data as SystemSetting;

        setSystemSetting(data);
    };

    return (
        <>
            <PageHeader
                title={pageHeader.title}
                breadcrumb={pageHeader.breadcrumb}
            ></PageHeader>

            <CreateEditSystemSetting id="" isEdit={true} setting={systemSetting} />
        </>
    );
}

